import React, { useState } from 'react'
import { Card, Select, Space } from 'antd'
import { useParams } from 'react-router'
import { useSelector } from 'react-redux'
import HumanReviewProgressChart from './HumanReviewProgressChart'
import HumanReviewProgressByReviewerChart from './HumanReviewProgressByReviewerChart'
import { QuestionCircleOutlined, UserOutlined } from '@ant-design/icons'
import assignmentSelectors from '../../../../../../../store/selectors/assignment.selectors'

const HumanReviewProgressCard = ({ title = 'Human Review Progress', showViewTypeSelector = true, initialViewType = 'reviewer' }) => {
    const { token } = useParams()
    const [viewType, setViewType] = useState(initialViewType)
    const workloadDistributed = useSelector(assignmentSelectors.workloadDistributed)
    return (
        <Card
            title={title}
            extra={
                showViewTypeSelector && workloadDistributed ? (
                    <Select
                        value={viewType}
                        onChange={setViewType}
                        style={{ width: 'fit-content' }}
                        variant='text'
                        options={[
                            {
                                value: 'question',
                                label: (
                                    <Space>
                                        <QuestionCircleOutlined />
                                        By Rubric
                                    </Space>
                                ),
                            },
                            {
                                value: 'reviewer',
                                label: (
                                    <Space>
                                        <UserOutlined />
                                        By Reviewer
                                    </Space>
                                ),
                            },
                        ]}
                        popupMatchSelectWidth={false}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                    />
                ) : null
            }
        >
            {viewType === 'question' ? (
                <HumanReviewProgressChart token={token} />
            ) : (
                <HumanReviewProgressByReviewerChart token={token} />
            )}
        </Card>
    )
}

export default HumanReviewProgressCard
